import { Action } from '@ngrx/store';
import { SponsoredListPaginatorInterface } from '../../models/sponsored.list.paginator.interface';

export enum ESponsoredListActions {
  GetSponsoredList = '[SPONSORSHIP] Get sponsored list',
  GetSponsoredListSuccess = '[SPONSORSHIP] Get sponsored list success',
}

export class GetSponsoredList implements Action {
  public readonly type = ESponsoredListActions.GetSponsoredList;
  constructor(public currentSelectedPage: number, public totalItemsPerPage: number) {}
}

export class GetSponsoredListSuccess implements Action {
  public readonly type = ESponsoredListActions.GetSponsoredListSuccess;
  constructor(public payload: SponsoredListPaginatorInterface) {}
}

export type SponsoredListActions = GetSponsoredList | GetSponsoredListSuccess;
